// home data
import orf from "../../assets/Home/orf.jpg";
import home from "../../assets/Home/greend (1).png";
import home3 from "../../assets/Home/fabrications.png";
import home2 from "../../assets/Home/slider-3.png";
import home4 from "../../assets/Home/it.png";
import home5 from "../../assets/Home/def_dispenser.png";
import NewImage from "../../assets/Home/newbg.jpg";
import Newsimg from "../../assets/Home/cbgimg.png";
import Newsimg1 from "../../assets/Home/cbgimg1.png";
import Newsimg3 from "../../assets/Home/cbgimg3.png";
import Newsimg2 from "../../assets/Home/cbgimg3.png";
import fuelmgmt from "../../assets/Home/biogas (1).png";
import industrial from "../../assets/Home/industrial.png";
import office from "../../assets/About/office.jpg";
import defDisp from "../../assets/About/defDisp.png";

import office2 from "../../assets/About/office2.png";
import setting from "../../assets/About/settings.png";
import tips from "../../assets/About/lightbulb.png";
import user from "../../assets/About/user copy.png";
import fertilizer from "../../assets/Home/fertilizer.png";
import quality from "../../assets/About/high-quality.png";
import creative from "../../assets/About/innovation.png";
import amazing from "../../assets/About/economic.png";
import cardimg1 from "../../assets/About/cardimg1.jpg";
import cardimg3 from "../../assets/About/cardimg2.jpg";
import cardimg4 from "../../assets/About/office2.png";
import cardimg5 from "../../assets/About/office.jpg";
import organic from "../../assets/About/organic.png";
import tank from "../../assets/About/tank.png";
import cbg from "../../assets/About/cbg.png";
import cardimg6 from "../../assets/About/cardimg5.jpg";
import cardimg7 from "../../assets/About/cardimg3.jpg";
import cardimg8 from "../../assets/About/teambg.jpg";
import lokeshsir from "../../assets/About/lokeshsir.jpg";
import BestPricing from "../../assets/About/money-banking.png";
import innovation from "../../assets/About/innovation (1).png";
import support from "../../assets/About/24-hours-support.png";
import fab from "../../assets/Home/oil-tank.png";
import asset from "../../assets/Home/dispenser.png";
import leader from "../../assets/Leadershipimg/leader.jpg";
import leader2 from "../../assets/Leadershipimg/leader4.jpg";
import leader3 from "../../assets/Leadershipimg/leader3.jpg";
import bgimage from "../../assets/Leadershipimg/Leadership2.jpg";
import teambg from "../../assets/Leadershipimg/man-avatar.png";

import hrmam from "../../assets/Leadershipimg/hrmam.jpeg";
import vivek from "../../assets/Leadershipimg/vivek.jpeg";
import cp from "../../assets/Leadershipimg/cp.jpg";
import daya from "../../assets/Leadershipimg/daya.jpg";
import dheeraj from "../../assets/Leadershipimg/dheeraj.jpg";
import Arshdip from "../../assets/Leadershipimg/Arshdeep.jpg";
import Arvind from "../../assets/Leadershipimg/Arvind.jpg";
import Rohit from "../../assets/Leadershipimg/Rohit.jpg";
import Manoj from "../../assets/Leadershipimg/Manoj.png";
import Pravin from "../../assets/Leadershipimg/Praveen.png";
import Laukhendrasir from "../../assets/Leadershipimg/lk.jpg";
import Ajaysir from "../../assets/Leadershipimg/ajaysir.jpg";
import Praphul from "../../assets/Leadershipimg/praphul.png";
import demo from "../../assets/Leadershipimg/team.jpeg";
import synergyimg from "../../assets/Products/syn2.png";
import Authorized from "../../assets/Products/update.png";
import safety from "../../assets/Products/safety1.png";
import payments from "../../assets/Products/operation.png";
import remote from "../../assets/Products/remote.png";
import realtime from "../../assets/Products/real-time.png";
import easier from "../../assets/Products/agreement.png";
import Hpcl from "../../assets/About/hpcl.png";
import Iocl from "../../assets/About/iocl.png";
import Bpcl from "../../assets/About/bpcl.png";
import Jpfms from "../../assets/About/jpfms.jpg";
import Laukhendra from "../../assets/About/lk.jpeg";
import Ajay from "../../assets/About/ajaysir.jpg";
import Lokesh from "../../assets/About/lokeshsir.jpg";
import synergykawach from "../../assets/synergycbg/synka.jpg";
import synergyFillnow from "../../assets/synergycbg/synergyFillnow.png";
import kawachic1 from "../../assets/Products/key-card.png";
import kawachic2 from "../../assets/Products/flexibility.png";
import kawachic3 from "../../assets/Products/server.png";
import kawachic4 from "../../assets/Products/unlock.png";
import kawachic5 from "../../assets/Products/gps.png";
import kawachic6 from "../../assets/Products/sensor.png";
import synergyfabrication from "../../assets/Synergyfabri/fab1.jpg";
import fab1 from "../../assets/Synergyfabri/brake (2).png";
import fab2 from "../../assets/Synergyfabri/fuel (2).png";
import fab3 from "../../assets/Synergyfabri/hose.png";
import fab4 from "../../assets/Synergyfabri/pto.png";
import fab5 from "../../assets/Synergyfabri/window.png";
import fab6 from "../../assets/Synergyfabri/fulefilter.png";
import fab7 from "../../assets/Synergyfabri/tank-truck.png";
import fab8 from "../../assets/Synergyfabri/fire-extinguisher.png";
import fab9 from "../../assets/Synergyfabri/lever box.png";
import fab10 from "../../assets/Synergyfabri/elock.png";
import fab11 from "../../assets/Synergyfabri/valve.png";
import fab12 from "../../assets/Synergyfabri/safety.png";
import green from "../../assets/SynergyGreen/greend.png";
import greend1 from "../../assets/SynergyGreen/composition.png";
import greend2 from "../../assets/SynergyGreen/planet-earth.png";
import greend3 from "../../assets/SynergyGreen/nomidi.png";
import greend4 from "../../assets/SynergyGreen/cost.png";
import greend5 from "../../assets/SynergyGreen/fuel (2).png";
import greend6 from "../../assets/SynergyGreen/safer.png";
import greend7 from "../../assets/SynergyGreen/cold.png";
import greend8 from "../../assets/SynergyGreen/lubricant.png";
import greend9 from "../../assets/SynergyGreen/financial.png";
import ben1 from "../../assets/SynergyGreen/cost.png";
import ben2 from "../../assets/SynergyGreen/planet-earth.png";
import ben3 from "../../assets/SynergyGreen/fuelbetter.png";
import ben4 from "../../assets/SynergyGreen/ontime.png";
// Dg
import bgdgimage from "../../assets/synergycbg/cbgs3.jpg";
import Fillbgimg from "../../assets/Fillnowimg/fl.jpg";
import fil1 from "../../assets/Fillnowimg/arg (2).png";
import fil2 from "../../assets/Fillnowimg/alert.png";
import fil3 from "../../assets/Fillnowimg/gps.png";
import fil4 from "../../assets/Fillnowimg/realttimed.png";
import fil5 from "../../assets/Fillnowimg/directions.png";
import fil6 from "../../assets/Fillnowimg/rfid (1).png";
import filbene1 from "../../assets/Fillnowimg/safety.png";
import filbene2 from "../../assets/Fillnowimg/convience.png";
import filbene3 from "../../assets/Fillnowimg/assurance.png";
import filbene4 from "../../assets/Fillnowimg/reconscillition.png";
import filbene5 from "../../assets/Fillnowimg/delive.png";
import filbene6 from "../../assets/Fillnowimg/saving.png";
import Gallary1 from "../../assets/Fillnowimg/gallery1.jpg";
import Gallary2 from "../../assets/Fillnowimg/gallery2.jpg";
import Gallary3 from "../../assets/Fillnowimg/gallery3.jpg";
import Gallary4 from "../../assets/Fillnowimg/gallery6.jpg";
import Gallary5 from "../../assets/Fillnowimg/gallery10.jpg";
import Gallary6 from "../../assets/Fillnowimg/gallery4.jpg";
import Gallary7 from "../../assets/Fillnowimg/gallery4.jpg";
import Gallary8 from "../../assets/Fillnowimg/gallery8.jpg";
import Gallary9 from "../../assets/Fillnowimg/gallery9.jpg";
import Itbgimage from "../../assets/itautomation/bg.jpg";
import Itautomation from "../../assets/itautomation/itautomation.png";
import Itautomation2 from "../../assets/itautomation/it2.png";
import cardimage1 from "../../assets/imagecard/card1.png";
import cardimage2 from "../../assets/imagecard/card2.png";
import cardimage3 from "../../assets/imagecard/card3.png";
import cardimage4 from "../../assets/imagecard/card4.png";
import cardimage5 from "../../assets/imagecard/card5.png";

import design1 from "../../assets/imagecard/design.png";
import design2 from "../../assets/imagecard/microchip.png";
import design3 from "../../assets/imagecard/ai.png";
import design4 from "../../assets/imagecard/deployment.png";
import Research1 from "../../assets/imagecard/research.png";
import Research2 from "../../assets/imagecard/research1.png";
import Research3 from "../../assets/imagecard/research2.png";
import Research4 from "../../assets/imagecard/reaserch3.png";
import Achieve1 from "../../assets/imagecard/calendar.png";
import Achieve2 from "../../assets/imagecard/world.png";
import Achieve3 from "../../assets/imagecard/team.png";
import catogry1 from "../../assets/imagecard/ind.png";
import catogry2 from "../../assets/imagecard/oil-tanker.png";
import catogry3 from "../../assets/imagecard/cbg1.png";
import catogry4 from "../../assets/imagecard/internet-of-things.png";
import catogry5 from "../../assets/imagecard/intelligence.png";
import sucessful1 from "../../assets/imagecard/sucess.jpg";
import sucessful2 from "../../assets/imagecard/sucess1.jpg";
import sucessful3 from "../../assets/imagecard/sucess2.jpg";
import sucessful4 from "../../assets/imagecard/sucess3.jpg";
import sucessful5 from "../../assets/imagecard/sucess4.jpg";
import faq from "../../assets/supportimage/faq.png";
import cbgasplant from "../../assets/Home/cbggas.jpg";
import bowsertanker from "../../assets/Home/tank1.jpg";
import defdisp from "../../assets/Home/def.png";
import contactimg from "../../assets/contactus/cntt2.jpg";
import location from "../../assets/contactus/location.png";
import phone from "../../assets/contactus/phone-call.png";
import faxx from "../../assets/contactus/phone-set.png";
import email from "../../assets/contactus/email.png";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import hirings from "../../assets/contactus/hiring.png";
import interv from "../../assets/contactus/interv.png";
import select from "../../assets/contactus/select.png";
import rectangle from "../../assets/contactus/rectan.jpg";
import circle from "../../assets/contactus/circle.jpg";
import fabrication from "../../assets/contactus/fabrication.jpg";
import petrol from "../../assets/contactus/petrol.jpg";
import sales from "../../assets/contactus/salespe.jpg";
import laptop from "../../assets/contactus/laptop.jpg";
import hrbtn from "../../assets/contactus/findjob.png";
import overlay1 from "../../assets/Home/choseus.jpg";
import overlay2 from "../../assets/Home/choseus2.jpg";
import cbgnews from "../../assets/Home/cbgnews.jpg";
// soluton i
import cbgs from "../../assets/Home/biogas (1).png";
import defdispenser from "../../assets/Home/dispenser.png";
import smartfuel from "../../assets/Home/real-time.png";
import tampings from "../../assets/Home/gas-station.png";
import bowser from "../../assets/Home/tanker.png";
import itautomation from "../../assets/Home/technical-support.png";
import synergyContenticon from "../../assets/synergycbg/greenenergy.png";
import synergyContenticon1 from "../../assets/synergycbg/eco-factory.png";
import synergyContenticon2 from "../../assets/synergycbg/biogas (3).png";
import cbgimage from "../../assets/synergycbg/cbghr.jpg";
import cbgbg from "../../assets/synergycbg/bg.jpg";
import mapbg from "../../assets/synergycbg/world-map-dark.png";
import areaCapacity from "../../assets/synergycbg/area-capacity.png";
import advcbg from "../../assets/synergycbg/adv.jpg";
import supplychain from "../../assets/synergycbg/chain.jpg";

// Homeslide data
export const  slides = [
  {
    id: 1,
    title: "Compressed BioGas: The Future of Sustainable Energy",
    subTitle: "GO GREEN WITH CBG",
    imgSrc: home,
  },
  {
    id: 2,
    title: "Precision Fabrication for Stronger, Smarter Structures",
    subTitle: "Built to Last, Engineered for the Future",
    imgSrc: home3,
  },
  {
    id: 3,
    title: "Revolutionizing Businesses with IT Automation",
    subTitle: "SMARTER, FASTER, EFFICIENT",
    imgSrc: home4,
  },
  {
    id: 4,
    title: "Saksham® – The Organic Fertilizer",
    subTitle: "Sustainable, Natural, Future-Ready",
    imgSrc: home2,
  },
  {
    id: 5,
    title: "DEF Dispensers – Clean, Efficient, Reliable",
    subTitle: "Optimizing Emissions with Precision",
    imgSrc: home5,
  }
  
];
export const description =
  "Saksham® Organic Fertilizers by Synergy Teletech Pvt. Ltd. promote sustainable, chemical-free farming through nutrient-rich products made at our Saharanpur CBG plant.";

export const services = [
  {
    icon: fuelmgmt,
    name: "Compressed BioGas ",
    description:
      " Compressed BioGas (CBG) is a sustainable and eco-friendly alternative fuel that plays a vital role in reducing carbon emissions and promoting energy efficiency. We provide advanced CBG solutions designed to optimize production, storage, and distribution. Our system integrates real-time monitoring tools to track gas generation, quality, and supply chains with precision, ensuring cost-effectiveness and environmental sustainability.",
  },
  {
    icon: fertilizer,
    name: "Organic Fertilizer", 
    description:
      "Sustainable. Natural. Future-Ready. Synergy Teletech Pvt. Ltd. proudly presents Saksham®, a high-quality organic fertilizer produced at our advanced CBG (Compressed Bio Gas) facility in Saharanpur, Uttar Pradesh. Designed to support sustainable agriculture, Saksham® is a nutrient-rich, eco-friendly fertilizer created through a natural and scientifically controlled anaerobic digestion process. As one of India’s leading green-energy initiatives, our Saharanpur plant produces thousands of tons of organic bio-fertilizer annually, making Saksham® a reliable and environmentally responsible choice for farmers across the country.",
  },
  {
    name: "Fabrication Services",
    icon: fab,
    description:
      "Fabrication & Bowser Manufacturing are at the core of industrial excellence, providing reliable solutions for diverse operational needs. We specialize in high-quality fabrication and bowser manufacturing, including bowser tanks ranging from 3KL to 9KL, catering to industries such as oil and gas, infrastructure, and energy. Our solutions integrate precision engineering and advanced technology to ensure durability, efficiency, and optimal performance in fuel storage and transportation.  ",
  },

  {
    name: "DEF Dispenser",
    icon: asset,
    description:
      "DEF Dispensers play a crucial role in reducing emissions and enhancing the performance of diesel engines by delivering high-purity Diesel Exhaust Fluid (DEF) efficiently. We offer state-of-the-art DEF dispensers designed for accuracy, durability, and seamless integration into fuel management systems. Our dispensers ensure precise fluid delivery, minimize wastage, and comply with industry standards, making them ideal for fleets, fuel stations, and industrial applications.",
  },
  {
    name: "IT & Automation",
    icon: industrial,
    description:
      "In the rapidly evolving oil and gas sector, IT and automation drive efficiency, safety, and innovation. We provide tailored solutions addressing industry challenges, helping businesses stay ahead. Our technology integrates IoT, AI, and cloud computing to streamline operations, enhance decision-making, and reduce costs. Features include live tracking for fuel and DEF dispensers, real-time monitoring of consumption patterns, automated fuel management to reduce pilferage, predictive maintenance for minimal downtime, and cloud-based analytics for optimized performance, ensuring smarter, more efficient fuel and asset management. ",
  },
  // {
  //   name: "Industrial Automation",
  //   icon: industrial1,
  //   description:
  //     "Industrial automation is revolutionizing the way industries operate, enabling businesses to streamline processes, enhance productivity, and reduce costs. At Synergy Teletech Pvt. Ltd., we specialize in delivering advanced automation solutions tailored to the unique requirements of industrial operations.By reducing manual intervention and enhancing safety protocols, industrial automation not only increases productivity but also ensures a safer working environment. ",
  // },
];

export const aboutUsContent = {
  title: "About Us",
  description:
    " India’s  One of the Biggest CBG Plants – A Landmark Project by Synergy Teletech Pvt. Ltd. We proudly stands at the forefront of India’s clean energy revolution with the development of one of the country’s largest Compressed Bio Gas (CBG) plants, located in Saharanpur, Uttar Pradesh. This milestone project reflects our commitment to sustainability, innovation, and nation-building.",
  defaultServiceDescription:
    "We specialize in delivering cutting-edge solutions, combining expertise in fuel management, industrial automation, manufacturing, fabrication, asset monitoring, and IT automation. Our approach integrates advanced technology and innovation to optimize processes, enhance productivity, and improve operational efficiency. From streamlining fuel usage and monitoring assets in real time to automating industrial operations and improving manufacturing workflows, we empower businesses to achieve their goals seamlessly.",
  buttonText: "Learn More",
  buttonLink: "/company-profile",
  image: NewImage,
};

// energySectionData.js
export const energySectionData = {
  heading: "Powering the Future",
  title: "Bio Gas & Fertilizers – A Vital Energy Source for a Sustainable Tomorrow",
  description:
    "We operates a major CBG plant in Saharanpur, converting organic waste into clean renewable energy. Alongside CBG, we produce Saksham® Organic Fertilizer, a nutrient-rich, chemical-free biofertilizer that improves soil health and supports sustainable farming—promoting a greener, eco-friendly future for energy and agriculture.",
  buttonLabel: "Discover More",
  items: [
    // {
    //   title: "Aspiration",
    //   description:
    //     "Our aspiration is to lead India toward a cleaner, greener future by converting waste into renewable energy and sustainable agricultural solutions.",
    // },
    {
      title: "Vision",
      description:
        "To be one of the World’s biggest clean fuel producers & petroleum retail automation service provider in terms of volume of fuel produced, delivered and number of customers served.",
    },
    {
      title: "Mission",
      description:
        "To propagate use of alternate clean fuel and to be customer centric, cost effective & most transparent fuel automation service provider in the world.",
    },
  ],
};

// solutionsData.js
export const solutionsData = {
  heading: "Powerful Solutions for a Sustainable Future",
  description1:
    "Empowering industries with innovative and efficient solutions, driving sustainability for a better tomorrow. Our cutting-edge technology and forward-thinking approach ensure reliability, efficiency, and environmental responsibility in every step we take.",
  items: [
    {
      title: "Automated CBG Production",
      description:
        "Enhancing compressed biogas (CBG) production with AI-driven automation for cleaner, efficient, and scalable energy output.",
      image: cbgs,
    },
    {
      title: "DEF Dispenser Technology",
      description:
        "Optimizing Diesel Exhaust Fluid (DEF) dispensing with smart automation, ensuring accuracy, efficiency, and reduced emissions.",
      image: defdispenser,
    },
    {
      title: "Smart Fuel Management System",
      description:
        "Utilizing AI-driven automation and IoT sensors to ensure precise fuel dispensing, minimize wastage, and enhance operational transparency real-time analytics.",
      image: smartfuel,
    },
    {
      title: "Smart Stamping & Pumping Solutions",
      description:
        "Innovative stamping and fluid transfer technologies ensuring precision, durability, and energy efficiency in industrial applications.",
      image: tampings,
    },
    {
      title: "Bowser Tanker Automation",
      description:
        "Implementing IoT-driven monitoring and automation for fuel bowser tankers, ensuring safe, efficient, and real-time tracking.",
      image: bowser,
    },

    {
      title: "IT Automation for Energy & Fuel Systems",
      description:
        "Harnessing AI, IoT, and cloud computing to streamline energy and fuel management, reducing costs and improving efficiency.",
      image: itautomation,
    },
  ],
};

export const petroleumData = {
  title: "Why Choose Us",
  heading:
    "Transforming Petroleum and Gas for a Sustainable and Resilient Future",
  description:
    "We pioneers sustainable petroleum solutions, ensuring cleaner energy, stronger performance, and a better future through innovation and responsible resource management",
  mainImage: overlay1,
  overlayImage: overlay2,
  progress: [
    { label: "Eco-Friendly Solutions", value: 90 },
    { label: "Performance & Efficiency", value: 75 },
    { label: "Innovation & Growth", value: 82 },
  ],
};

export const petroleumcard = {
  title: "Our Awesome Projects",
  heading: "We Take All Related Oil & Gas Projects",
  description:
    "We provide advanced solutions in the petroleum industry, ensuring efficiency and sustainability.",
  projects: [
    {
      title: "CBG",
      description:
        "Compressed Bio-Gas solutions for sustainable and efficient energy use.",
      image: cbgasplant,
    },
    {
      title: "DEF Dispensers",
      description:
        "Ensuring accurate calibration and compliance for petrol pumps.",
      image: defdisp,
    },
    {
      title: "Fabrication Services",
      description:
        " fabrications services: Efficient, safe, mobile fuel dispensing for industries.",
      image: bowsertanker,
    },
  ],
};

export const mainNews = {
  title: "The Future of Compressed Biogas (CBG) in Global Energy Markets",
  description:
    "Compressed Biogas (CBG) is transforming energy markets as a renewable alternative to fossil fuels. With growing demand, policy support, and technological advancements, CBG is set to drive sustainability in transportation, industry, and power generation worldwide.",
  image: cbgnews,
  label: "BUSINESS GROWTH",
  link: "#",
};

export const articles = [
    {
    title: "FABRICATION SERVICES",
    description: "Precision Manufactured Tankers Built for Strength, Safety and Reliability",
    image: Newsimg,
    link:"/synergy-fabrication"
  },
  {
    title: "IT AND AUTOMATION",
    description: "Streamlining Operations Through Intelligent IT and Automation Integration",
    image: Newsimg1,
        link:"/it-automation"

  },
  {
    title: "ORGANIC FERTILIZERS",
    description: " - Saksham® Organic Fertilizers for Healthier Soil and Higher Crop Yields",
    image: Newsimg3,
            link:"/synergy-organic-fertilizer"

  },
];

export const companyDescription = `

The company is also in receipt of LOI from BPCL & GAIL for setting up Compressed Bio Gas Plants in multiple locations in India. Through this setup, company will extend its offering of including more and cleaner Biofuels for customers. The company is also considering setting up green energy Retail Outlets for its customers. The 1st CBG plant is being setup in Saharanpur, which is a pressmud based CBG plant to generate approx. 14 MT of CBG per day, approx. 80 Tons of PROM & 100 KL of LFOM.


`;
export const companyDescription2 = `

The company is also a pioneer in providing technology for Automated Door delivery and providing Solutions for Automation in Petroleum retail Outlets.
Synergy Drishti is pathbreaking Automation Solution for Petroleum Retail Outlets, Consumer Pumps and Biodiesel Retail Outlet. Drishti is a hardware independent application which can be used to monitor and control all Forecourt equipments like Fuel Dispensers and Tank Level Sensors. The solution is very innovative and can be customized as per customer’s needs.
FillNow® is the Automated Fuel door delivery service that comes to the location of the stationary equipment and delivers Synergy Green Diesel® directly into it – on demand when the consumer needs it. It eliminates the need to store bulk fuel on site and all the problems with self-transporting & fueling the machinery. Now customers, just by sitting at their office from a simple phone call or click/tap from their fingers, can order for fuel and it can be delivered to their premises in a fully automated mechanism and most transparent way. The Refueller designed by the company is technologically advanced, safe and is patented. With FillNow® service, the company claims prompt on-site delivery of fuel. Its tag line rightly says “Fuel Delivered. Anywhere.”

Synergy Kawach is an in house developed electronic lock, designed specifically for machinery used in the infra business. The main objective of the lock is to monitor the asset and check fuel pilferage after fuel has been supplied inside the fuel tank.



`;
export const companyDescription3 = `

The company also has its straight of the art fabrication unit for manufacturing of Top & Bottom Loading TTs & Automated Fuel Bowsers for Door Delivery of Diesel. Till date company has delivered more than 250 bowsers in various parts of the country. The fabrication unit is situated in Faridabad, Haryana.

`;
export const companyDescription4 = `


The company is also into the manufacturing of cloud connected DEF Dispensers. We recently supplied more than 100 nos of such IoT based Dispensers to various BPCL COCO Outlets, along with full server application for remote access.



`;

export const companyIntroduction = `
Synergy Teletech Private Limited started its journey as India’s 1st and only organized entity that provided Automated On-Site Delivery of Diesel/Biodiesel through its FillNow® Service. The company is now one of most renowned names in providing technology for Automated Door Delivery of Diesel & Retail Automation. The company is headquartered in Noida and deals in many businesses verticals in Petroleum & Gas Industry.
`;

export const companyMission =   `
Our mission is to revolutionize the fuel delivery industry by providing an efficient, transparent, and reliable 
automated refueling system. We aim to eliminate fuel pilferage and ensure every drop of fuel reaches its intended purpose 
through cutting-edge technology and innovation.
`;

// Company Profile

export const teamData = [
  {
    image: Laukhendra,
    name: "Laukhendra Singh",
    Designation: "Tech Head",
    description:
      "Laukhendra leads the tech team, ensuring smooth innovation and reliable digital solutions at Synergy Teletech.",
  },
  {
    image: Lokesh,
    name: "Lokesh Mathur",
    Designation: "Operations Manager",
    description:
      "Lokesh manages daily operations, optimizing logistics and efficiency to improve service delivery and workflow.",
  },
  {
    image: Ajay,
    name: "Ajay Singh",
    Designation: "Sales Manager",
    description:
      "Ajay drives sales growth, builds strong client relationships, and ensures customer satisfaction at Synergy Teletech.",
  },
  {
    image: hrmam,
    name: "Aastha Tomer",
    Designation: "HR & Admin Manager",
    description:
      "Aastha oversees HR functions, fostering a great work culture and managing administrative operations efficiently.",
  },
  {
    image: vivek,
    name: "Vivek Kumar",
    Designation: "Senior engineer (Pan India)",
    description:
      "",
  },
  {
    image: cp,
    name: "Chandra Pal",
    Designation: "Sr. Service Engineer",
    description:
      "",
  },
  {
    image: daya,
    name: "Daya Shanker",
    Designation: "Depot Incharge",
    description:
      "",
  },
  {
    image: dheeraj,
    name: "Dheeraj Kumar",
    Designation: "Junior Service Engineer",
    description:
      "",
  },
];

export const clients = [
  {
    image: Hpcl,
    name: "HPCL",
  },
  {
    image: Iocl,
    name: "IOCL",
  },
  {
    image: Bpcl,
    name: "BPCL",
  },
  {
    image: Jpfms,
    name: "JPFMS",
  },
];

// content.js

// Mision
export const Itservice = [
  {
    title: "CBG (Compressed Bio Gas)",
    img: tips,
    image: cbg,
    highlight: false,
    features: [
      "Eco-friendly Fuel Solution",
      "High Energy Efficiency",
      "Cost-effective Alternative",
      "Sustainable Energy Source",
    ],
  },
   {
    title: "ORGANIC FERTILIZER",
    img: fertilizer,
    image: organic,
    highlight: false,
    features: [
      "100% Natural ingredients",
      "Improve soil health",
      "Long-lasting nutrient release",
      "Eco-friendly and safe",
    ],
  },
 
  {
    title: "IT AUTOMATION SERVICES",
    img: user,
    image: office2,
    highlight: false,
    features: [
      "AI-Powered Workflow Automation",
      "Cloud & DevOps Solutions",
      "Intelligent Data Processing",
      "24/7 IT Support & Monitoring",
    ],
  },
   {
    title: "BOWSER TANKER MANAGEMENT",
    img: setting,
    image: tank,
    highlight: true,
    features: [
      "Real-time Tanker Monitoring",
      "Automated Fuel Dispensing",
      "GPS & Route Optimization",
      "Enhanced Security Features",
    ],
  }, 
 
];
export const servicesCarousel = {
  
  cards: [
    {
      icon: "♻️", // Recycling/renewable energy
       image: cbg,
      title: "CBG (Compressed Bio Gas)",
       link: "/synergy-dg",
      description:[
      "Eco-friendly Fuel Solution",
      "High Energy Efficiency",
      "Cost-effective Alternative",
      "Sustainable Energy Source",
     
    ],
    },
    {
      icon: "🌱", // organic fertilizer
       image: organic,
      title: "ORGANIC FERTILIZER",
      link: "/synergy-organic-fertilizer",

      description:
       [
      "100% Natural ingredients",
      "Improve soil health",
      "Long-lasting nutrient release",
      "Eco-friendly and safe",
    ],
    },
    {
      icon: "🔬", // IT AUTOMATION SERVICES
      image: office2,
      title: "IT AUTOMATION SERVICES",
             link: "/it-automation",

      description:
       [
      "AI-Powered Workflow Automation",
      "Cloud & DevOps Solutions",
      "Intelligent Data Processing",
      "24/7 IT Support & Monitoring",
    ],
    },
    {
      icon: "🛠️",
       image: tank,
      title: "FABRICATION SERVICES",
             link: "/synergy-fabrication",

      description:
       [
       "Real-time Tanker Monitoring",
      "Automated Fuel Dispensing",
      "GPS & Route Optimization",
      "Enhanced Security Features",
    ],
    },
    {
      icon: "⛽", // "def dispenser",
       image: defDisp,
      title: "DEF Dispensers",
             link: "/synergy-def-dispenser",

      description:
       [
       "Accurate Delivery",
      "Emission Control",
      "Safe Storage & Handling",
      "Operational Efficiency",
    ],
    },
  ],
  thumbnail: {
    image: "cbg-video-thumbnail.jpg",
    alt: "CBG Production Video",
  },
};

export const serviceface = [
  {
    title: "High Quality",
    icimage: quality,
    article:
      "We ensure top-notch quality in CBG production and IT automation, enhancing efficiency and sustainability in every process.",
  },
  {
    title: "Creative Mind",
    icimage: creative,
    article:
      "Our innovative approach to CBG solutions, Bowser Tanker management, and IT automation helps businesses optimize operations and maximize growth.",
  },
  {
    title: "Amazing Result",
    icimage: amazing,
    article:
      "From sustainable CBG and organic fertilizer solutions to IT automation and intelligent tanker/bowser monitoring, we empower your business with efficiency, accuracy, and innovation.",
  },
  {
    title: "Best Pricing",
    icimage: BestPricing,
    article:
      "We provide cost-effective solutions for CBG energy, Organic Fertilizers, and IT automation, ensuring high returns while reducing operational costs.",
  },
  {
    title: "Innovation",
    icimage: innovation,
    article:
      "Harnessing the latest technology, we drive innovation in CBG production, automated tanker tracking, and AI-driven IT solutions to enhance productivity.",
  },
  {
    title: "24/7 Support",
    icimage: support,
    article:
      "Our dedicated team is available round-the-clock to support your CBG infrastructure, Bowser Tanker operations, and IT automation needs.",
  },
];

export const cardservice = [
  {
    title: "MARKETING",
    description:
      "Promote CBG solutions, Bowser Tanker services, and IT automation with targeted strategies to drive industry growth.",
    image: cardimg1,
  },
  {
    title: "FLEXIBILITY",
    description:
      "Adaptable solutions for CBG production, Organic fertilizer and IT automation to meet diverse business needs efficiently.",
    image: "flexibility-image-path.jpg",
  },
  {
    title: "",
    description: "",
    image: cardimg3,
  },

  {
    title: "",
    description: "",
    image: cardimg4,
  },
  {
    title: "",
    description: "",
    image: cardimg5,
  },
  {
    title: "",
    description: "",
    image: cardimg6,
  },
  {
    title: "",
    description: "",
    image: cardimg7,
  },

  {
    title: "MARKETING",
    description:
      "Promote CBG solutions, Bowser Tanker services and IT automation with targeted strategies to drive industry growth.",
    image: cardimg1,
  },
];

export const teammisionData = [
  {
    Image: cardimg8,
    sections: [
      {
        title: "Empowering Businesses with Innovative Technology",
        text: "At Synergy Teletech, we are committed to providing cutting-edge technology solutions that drive business efficiency and digital transformation. Our expertise in communication, IT infrastructure, and software solutions ensures that businesses stay ahead in an ever-evolving digital landscape.",
      },
      {
        title: "Transforming Connectivity, Enhancing Productivity",
        text: "With a strong focus on innovation and customer-centric solutions, Synergy Teletech continues to expand its reach, delivering high-performance telecom and IT services across industries. Our mission is to empower organizations with seamless connectivity and robust technological solutions that foster growth and success.",
      },
    ],
    footer: {
      text: "Image from",
      linkText: "Freepik",
    },
  },
];

// Leadership data
export const leadershipData = [
  {
    image: leader,
    name: "Prasan Surana",
    title: "- Founder & CEO",
    description:
      "Prasan is a Biofuel enthusiast and have been instrumental in providing MSMEs with Biodiesel in NCR region. The Automated doorstep delivery of Biodiesel, via FillNow, has been hailed as one of the most organised services in this sector. The company under his leadership is also building Bio refineries and Biofuel plants in various locations in North India. Prasan has vast insights on fuel retailing and the hardships people face while carrying fuel for stationary equipment. His startup, FillNow, typically focuses on this aspect. Apart from Automation in Fuel Door delivery, Prasan has been actively involved and developed Cloud based Automation Applications for Petroleum Gas Stations. The solution is extremely simple, easy to use and needs minimum hardware and cabling to connect and integrate forecourt equipments. Prasan also heads the Tank Truck Fabrication Vertical. This PESO Licensed arm of the company handles the Fabrication of Top and Bottom Loading Petroleum Road Tankers. Prasan is an engineer by qualification from NIT Silchar (2007), he worked with BPCL for 4.5 years before starting this venture. He manages the day to day operations of the Business.",
  },
  {
    image: leader2,
    name: "Tinku Surana",
    title: "- Co-Founder",
    description:
      "Tinku is a qualified Company Secretary (CS) and also holds LLB Degree from Assam University, Silchar. Tinku has been instrumental in looking after this role since the beginning, right from company incorporation stage. She heads the Admin, HR, Legal and Compliance department in the company.",
  },
  {
    image: leader3,
    name: "Surendra Bardia",
    title: "- Advisor",
    description:
      "Surendra is an entrepreneur and angel investor with a advisory role in several early and mid-stage ventures across different verticals .",
  },
];

export const leadershipContent = {
  heroImage: bgimage,
  sectionTitle: "Meet our leadership team",
  sectionDescription:
    "Our leadership team at Synergy Teletech Pvt Ltd exemplifies inspiration and motivation, driving our mission with unwavering dedication and vision. Each leader brings unique expertise and a shared passion for innovation, fostering a culture of excellence and collaboration. Through their commitment, they empower teams to break boundaries, embrace challenges, and achieve extraordinary results.",
  buttonText: "Learn more",
  promiseTitle: "Commitment to Our Communities",
  promiseDescription:
    "At Synergy Teletech Pvt Ltd, we believe our social mission and business mission are one and the same. We know our company and the services we offer can change the world. We start with our own community, building impactful connections and driving meaningful change. We know it is ambitious, but we think our pledge of time, talent, and profit is a great start.",
  timeSection: {
    title: "OUR TIME",
    description:
      "We dedicate our time to delivering innovative solutions that empower businesses with efficiency and quality.",
    link: "#!",
  },
  cultureSection: {
    title: "OUR CULTURE",
    description:
      "Our culture thrives on teamwork, innovation, and a customer-first approach, fostering creativity and growth.",
    link: "#!",
  },
};

export const Ourteam = [
  
  {
    profileImg: Laukhendrasir,
    name: "Laukhendra Singh",
    title: "App Developer",
    // description: "12+ Years Of Experience",
    // socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/laukhendra-singh",
    //   facebook: "https://facebook.com/laukhendra.singh",
    //   twitter: "https://twitter.com/laukhendrasingh",
    // },
  },
 
  {
    profileImg: Manoj,
    name: "Manoj Kumar",
    title: "Project Manager",
    // description: "10+ Years Of Experience",
    // socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/manoj-singh",
    //   facebook: "https://facebook.com/manoj.singh",
    //   twitter: "https://twitter.com/manojsingh",
    // },
  },
  {
    profileImg: Pravin,
    name: "Pravin Singh",
    title: "Java Developer",
    // description: "8+ Years Of Experience",
    // socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/pravin-singh",
    //   facebook: "https://facebook.com/pravin.singh",
    //   twitter: "https://twitter.com/pravinsingh",
    // },
  },
  
  {
    profileImg: Arvind,
    name: "Arvind Chaudhary",
    title: "MERN Developer",
    // description: "6+ Years Of Experience",
    // socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/arvind-chaudhary",
    //   facebook: "https://facebook.com/arvind.chaudhary",
    //   twitter: "https://twitter.com/arvindchaudhary",
    // },
  },
  {
    profileImg: Rohit,
    name: "Rohit",
    title: "PHP Developer",
    // description: "1+ Years Of Experience",
    // socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/rohit",
    //   facebook: "https://facebook.com/rohit",
    //   twitter: "https://twitter.com/rohit",
    // },
  },
  {
    profileImg: Ajaysir,
    name: "Ajay Singh",
    title: "Business Development Associate",
    // description: "+4 Years Of Experience",
    // socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/ajay-singh",
    //   facebook: "https://facebook.com/ajay.singh",
    //   twitter: "https://twitter.com/ajaysingh",
    // },
  },
 
  {
    profileImg: lokeshsir,
    name: "Lokesh Mathur",
    title: "Operation Manager",
    // description: "+4 Years Of Experience",
    // socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/lokesh-mathur",
    //   facebook: "https://facebook.com/lokesh.mathur",
    //   twitter: "https://twitter.com/lokeshmathur",
    // },
  },
  {
    profileImg: hrmam,
    name: "Aastha Tomar",
    title: "HR Manager",
    // description: "+4 Years Of Experience",
    // socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/aastha-tomar",
    //   facebook: "https://facebook.com/aastha.tomar",
    //   twitter: "https://twitter.com/aasthatomar",
    // },
  },
  {
    profileImg: vivek,
    name: "Vivek Kumar",
    title: "Senior engineer (Pan India)",
    // description:
    //   "+4 Years Of Experience",
    //   socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/vivek",
    //   facebook: "https://facebook.com/vivek",
    //   twitter: "https://twitter.com/vivek",
    // },
  },
  {
    profileImg: cp,
    name: "Chandra Pal",
    title: "Sr. Service Engineer",
    // description:
    //    "+4 Years Of Experience",
    //    socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/vivek",
    //   facebook: "https://facebook.com/vivek",
    //   twitter: "https://twitter.com/vivek",
    // },
  },
  {
    profileImg: daya,
    name: "Daya Shanker",
    title: "Depot Incharge",
    // description:
    //    "+4 Years Of Experience",
    //    socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/vivek",
    //   facebook: "https://facebook.com/vivek",
    //   twitter: "https://twitter.com/vivek",
    // },
  },
  {
    profileImg: dheeraj,
    name: "Dheeraj Kumar",
    title: "Junior Service Engineer",
    // description:
    //    "+4 Years Of Experience",
    //    socialLinks: {
    //   linkedin: "https://www.linkedin.com/in/vivek",
    //   facebook: "https://facebook.com/vivek",
    //   twitter: "https://twitter.com/vivek",
    // },
  },
];

export const Synergydrishti = {
  heroImg: synergyimg,
  title: "Overview ",
  description:
    "As the name suggests, it allows you to remotely manage your petroleum retail outlet from anywhere, increasing efficiency and control",
  description1:
    "Synergy Drishti is an automation application designed by our in-home team for managing and monitoring your retail outlet and consumer station. It focuses on the automation of the retail outlet resulting in the reduction of time constraints theft and pilferage of fuel. Now you can monitor all the activities happening on the pump (quantity of fuel dispensed/received in various equipment) and can verify dispense data on a real-time basis at your comfort. Minimal hardware and wireless connection are the main USP of Drishti",
  description2: " Prominent Features, Remarkable Benefits.",
};

export const featuresData = [
  {
    image: Authorized,
    title: "Automated Authorization",
    description:
      "Our automation ensures fuel gets delivered effectively and efficiently and is recorded properly.",
  },
  {
    image: safety,
    title: "Safety",
    description:
      "We deploy industry-best equipment and safety standards with our automation system.",
  },
  {
    image: payments,
    title: "Easy Payment",
    description:
      "You can make payments for fuel either in online or offline mode.",
  },
  {
    image: remote,
    title: "Remote Monitoring & Management",
    description:
      "Our automation ensures fuel gets delivered effectively and efficiently and is recorded properly.",
  },
  {
    image: realtime,
    title: "Real-Time Data Verification",
    description:
      "We deploy industry-best equipment and safety standards with our automation system.",
  },
  {
    image: easier,
    title: "Easier Reconciliation",
    description:
      "You can make payments for fuel either in online or offline mode.",
  },
];

export const Synergykawach = {
  heroImg: synergykawach,
  title: "Overview ",
  description:
    "Mobile dispensers are available for door delivery with a PESO license and fully automated system. Synergy mobile dispensers come in sizes ranging from 3KL to 6 KL and can be customized to suit customers' needs, depending on size and weight requirements",
  description1:
    "Synergy is a leading supplier of mobile fuel dispensers and door delivery Bowsers & Petroleum Tankers. Backed by years of experience, we have developed automated mobile diesel door delivery bowers and offer Bowser+ services for personal fuel dispensed We have fabricated and supplied over 200 bowsers and continue to provide stellar after-sales service. To discover the benefits of Bowser and own a mobile fuel dispenser, get in touch with us today",
  description2:
    "Unique Bowsers are made of superior quality products at competitive prices. Tanker body having a shell thickness of 3.15 mm plated in accordance with Petroleum Rules Schedule -3 .Epoxy coated inside tanks including aluminum shutters that are dust and fire resistant . Our bowsers are categorized: basic, essential, advanced, & premium.  The Bowsers meet ISO 9001:2015 standards and are assembled with next generation welding technology, branded MS sheets, certified Geo-fencing devices, and advanced technology. These have been road tested and perfected for over two decades, and no competition can beat them. Increase sales and give excellent after-sales service after fabrication. It's known as the Bowser+ promise. These Bowsers are designed with diverse terrains and needs in mind, and include features mention below",
};
export const FillNow = {
  heroImg: synergyFillnow,
  title: "Overview ",
  description:
    "Mobile dispensers are available for door delivery with a PESO license and fully automated system. Synergy mobile dispensers come in sizes ranging from 3KL to 6 KL and can be customized to suit customers' needs, depending on size and weight requirements",
  description1:
    "Synergy is a leading supplier of mobile fuel dispensers and door delivery Bowsers & Petroleum Tankers. Backed by years of experience, we have developed automated mobile diesel door delivery bowers and offer Bowser+ services for personal fuel dispensed We have fabricated and supplied over 200 bowsers and continue to provide stellar after-sales service. To discover the benefits of Bowser and own a mobile fuel dispenser, get in touch with us today",
  description2:
    "Unique Bowsers are made of superior quality products at competitive prices. Tanker body having a shell thickness of 3.15 mm plated in accordance with Petroleum Rules Schedule -3 .Epoxy coated inside tanks including aluminum shutters that are dust and fire resistant . Our bowsers are categorized: basic, essential, advanced, & premium.  The Bowsers meet ISO 9001:2015 standards and are assembled with next generation welding technology, branded MS sheets, certified Geo-fencing devices, and advanced technology. These have been road tested and perfected for over two decades, and no competition can beat them. Increase sales and give excellent after-sales service after fabrication. It's known as the Bowser+ promise. These Bowsers are designed with diverse terrains and needs in mind, and include features mention below",
};

export const kawachsData = [
  {
    image: kawachic1,
    title: "Keyless",
    description: "Keyless Electromechanical based Locking System",
  },
  {
    image: kawachic2,
    title: "Flexibility",
    description:
      "Flexible to be integrated with makes and type of all equipment’s in infra industry.",
  },
  {
    image: kawachic3,
    title: "Real time server",
    description:
      "Hands free, keyless operation with real time data sync with servers..",
  },
  {
    image: kawachic4,
    title: "Lock opening",
    description:
      "Lock opening possible wirelessly even in areas of LOW/ NO GSM connectivity.",
  },
  {
    image: kawachic5,
    title: "GPS In build",
    description:
      "We deploy industry-best equipment and safety standards with our automation system.",
  },
  {
    image: kawachic6,
    title: "sensors",
    description: "Integrated with hand sensors.",
  },
];

export const SynergyFab = {
  heroImg: synergyfabrication,
  title: "Overview ",
  description:
    "Mobile dispensers are available for door delivery with a PESO license and fully automated system. Synergy mobile dispensers come in sizes ranging from 3KL to 6 KL and can be customized to suit customers' needs, depending on size and weight requirements",
  description1:
    "Synergy is a leading supplier of mobile fuel dispensers and door delivery Bowsers & Petroleum Tankers. Backed by years of experience, we have developed automated mobile diesel door delivery bowers and offer Bowser+ services for personal fuel dispensed We have fabricated and supplied over 200 bowsers and continue to provide stellar after-sales service. To discover the benefits of Bowser and own a mobile fuel dispenser, get in touch with us today",
  description2:
    "Unique Bowsers are made of superior quality products at competitive prices. Tanker body having a shell thickness of 3.15 mm plated in accordance with Petroleum Rules Schedule -3 .Epoxy coated inside tanks including aluminum shutters that are dust and fire resistant . Our bowsers are categorized: basic, essential, advanced, & premium.  The Bowsers meet ISO 9001:2015 standards and are assembled with next generation welding technology, branded MS sheets, certified Geo-fencing devices, and advanced technology. These have been road tested and perfected for over two decades, and no competition can beat them. Increase sales and give excellent after-sales service after fabrication. It's known as the Bowser+ promise. These Bowsers are designed with diverse terrains and needs in mind, and include features mention below",

  description4:
    "Diesel dispensing machines are highly versatile and cater to a wide range of industries and applications. Their precision, durability, and efficiency make them a critical component in operations requiring the controlled and accurate transfer of diesel fuel. Below are some common applications",
};

export const fabfeaturesData = [
  {
    image: fab1,
    title: "Brake Interlock System",
    description:
      "Prevents vehicle movement during fuel dispensing or other automated processes, ensuring safety and compliance.",
  },
  {
    image: fab2,
    title: "Compact Fuel Dispenser",
    description:
      "Space-efficient and equipped with advanced metering for precise fuel delivery.",
  },
  {
    image: fab3,
    title: "Self-Retractable Hose Reel",
    description:
      "Automatically retracts hoses after use, improving safety and extending hose life.",
  },
  {
    image: fab4,
    title: "PTO (Power Take-Off)",
    description:
      "Transfers engine power to fuel pumps for efficient fuel transfer, ideal for mobile systems.",
  },
  {
    image: fab5,
    title: "Aluminum Shutter",
    description:
      "Lightweight and corrosion-resistant, offering robust protection for equipment.",
  },

  {
    image: fab6,
    title: "Inlet Filter",
    description:
      "Removes impurities from fuel to protect the system and ensure high-quality dispensing.",
  },
  {
    image: fab7,
    title: "Automatic Tank Gauging (ATG)",
    description:
      "Monitors fuel levels, temperature, and inventory in real time, enhancing efficiency and compliance.",
  },

  {
    image: fab8,
    title: "DCP Type Fire Extinguisher",
    description:
      "Portable fire extinguisher designed for Class B and C fires, ensuring safety during emergencies.",
  },
  {
    image: fab9,
    title: "Lever Box",
    description:
      "Provides precise control over fuel dispensing operations, ensuring reliable performance.",
  },
  {
    image: fab10,
    title: "E-Lock Technology",
    description:
      "Electronic locks prevent unauthorized access and ensure secure fuel operations.",
  },
  {
    image: fab11,
    title: "Valve Box (Stainless Steel)",
    description:
      "Protects valves in the system with durable, corrosion-resistant housing for long-term reliability.",
  },
  {
    image: fab12,
    title: "Safety Equipment and Tool Kit",
    description:
      "Includes essential tools and safety gear for emergency handling and routine maintenance.",
  },
];

export const SynergyGreen = {
  heroImg: green,
  title: "Overview ",
  description:
    "We offers advanced Diesel Exhaust Fluid (DEF) Dispenser solutions designed to meet the increasing demands of modern emission-controlled diesel engines. Engineered for accuracy, durability, and operational efficiency, our DEF dispensers are a perfect fit for fuel stations, transport fleets, industrial depots, and logistics hubs.",
  
};
export const SynergyOrganicFertilizerContent = {
  heroImg: orf,
  title: "Overview ",
  description:
    "Our Saksham® Organic Fertilizers, produced at Synergy Teletech Pvt. Ltd., Saharanpur, are made from fully natural, nutrient-rich materials. Designed to restore soil health, improve crop productivity, and support sustainable farming, our fertilizers provide a chemical-free, eco-friendly solution for agriculture, horticulture, and land development. They strengthen soil structure, boost microbial life, and help farmers achieve long-term soil fertility with minimal environmental impact.",
  // description1:
  //   "Synergy Green Diesel has a great positive impact on the environment. CO2, NOx and particulate emissions are reduced dramatically, as well as there is no black smoke due to the absence of aromatic compounds. Synergy Green Diesel conforms to EURO VI standards and outperforms petroleum diesel in performance, mileage & price.",

  // description2:
  //   "Though we serve all commercial sectors, our focus market is Non-Transport, as we ensure last mile connectivity. Accordingly, Synergy Green Diesel has specially formulated for stationary Engines & Gensets to use as a drop in fuel. Since Synergy Green Diesel is available On-Site, our primary focus is to serve those consumers who find difficulty in carrying fuel from Petroleum Retail Outlet to end location.",

  // description4:
  //   "Though we serve all commercial sectors, our focus market is Non-Transport, as we ensure last mile connectivity. Accordingly, Synergy Green Diesel has specially formulated for stationary Engines & Gensets to use as a drop in fuel. Since Synergy Green Diesel is available On-Site, our primary focus is to serve those consumers who find difficulty in carrying fuel from Petroleum Retail Outlet to end location .",
  // description5: "",
};

export const SynergyGreendata = [
  {
    image: greend1,
    title: "Accurate Dispensing",
    description:
      "High-precision flow meters ensure consistent and reliable DEF delivery with minimal wastage.",
  },
  {
    image: greend2,
    title: "Robust Construction",
    description:
      "Built with corrosion-resistant materials suitable for industrial and outdoor environments.",
  },
  {
    image: greend3,
    title: "Advanced Metering Technology",
    description:
      "Integration of digital metering and monitoring systems for real-time measurement.",
  },
  {
    image: greend4,
    title: "User-Friendly Interface",
    description: "Ergonomic design with easy-to-operate controls for smooth fueling operations.",
  },
  {
    image: greend5,
    title: "Safety Compliance",
    description:
      "Designed to meet industry safety standards, reducing risks of spills and contamination.",
  },

  {
    image: greend6,
    title: "Digital Connectivity",
    description:
      "Options for IoT integration, automated reporting, and remote system diagnostics.",
  },
  
];
export const SynergyWhyChooseData = [
  {
    title: "Proven Performance",
    description:
      "High reliability even in demanding environments.",
  },
  {
    image: greend2,
    title: "Customizable Solutions",
    description:
      "Tailored systems to suit your specific business needs",
  },
  {
    image: greend3,
    title: "Technical Support",
    description:
      "End-to-end after-sales service including installation, maintenance, and training.",
  },
  {
    image: greend4,
    title: "Seamless Integration",
    description: "Compatible with automation, fuel management systems, and reporting tools.",
  },
  
  
];
export const SynergyORFFeatures = [
  {
    image: greend1,
    title: " 100% Natural Composition",
    description:
      "Made from organic biomass with no synthetic chemicals.",
  },
  {
    image: greend2,
    title: "Microbial Enrichment",
    description:
      "Contains beneficial microorganisms to support soil regeneration.",
  },
  {
    image: greend3,
    title: "Moisture Retention",
    description:
      "Improves soil’s natural ability to hold water and reduce irrigation needs.",
  },
  {
    image: greend4,
    title: "Enhanced Plant Growth",
    description: "Supports healthy root development and increases crop yield.",
  },
  {
    image: greend5,
    title: "Eco-Friendly Production",
    description:
      "Processed through sustainable composting and treatment methods.",
  },

  {
    image: greend6,
    title: "Quality Testing & Lab Approval",
    description:
      "Each batch is tested to ensure nutrient balance and safety.",
  },
  {
    image: greend7,
    title: "Bulk Supply & Delivery Service",
    description: "We provide consistent supply for farms, nurseries, and large agricultural projects.",
  },
  {
    image: greend8,
    title: "Customized Soil-Based Solutions",
    description:
      "Fertilizer blends can be tailored as per soil conditions and crop requirements.",
  }
  
];

export const SynergyBenefits = [
  {
    image: ben1,
    title: "Fuel Retail Outlets",
   
  },
  {
    image: ben2,
    title: "Commercial Transport Fleets",
    
  },
  {
    image: ben3,
    title: "Mining & Construction Sites",
    
  },
  {
    image: ben4,
    title: "Industrial Fueling Depots",
    
  },
  {
    image: ben4,
    title: "Agricultural Operations",
    
  },
  {
    image: ben4,
    title: "Fleet Maintenance Facilities",
   
  },
];

export const SynergyGreenDg = {
  heroImg: bgdgimage,
  title: "Overview ",
  description:
    "With DG Pilferage Control System, we close the next loophole in chain, i.e, fuel pilferage from DG tank. It is observed that diesel can be siphoned out from the Tanks of DG in remote rural areas. With the installation of our devices, this activity can be virtually eliminated. Our in depth field experience has let us to design this highly effective diesel pilferage control system and has demonstrated great success and resulted in high savings in diesel consumption in remote sites. Also, we can monitor these sites from anywhere, as all equipments on DGs/BTS can be controlled by our “Smart Controller”. Hence our customers can very easily have a transition from manned sites to unmanned sites We can proudly declare that our Pilferage control system is the most cost efficient yet most effective mechanism available in market today",

  description1:
    "Synergy Green Diesel has a great positive impact on the environment. CO2, NOx and particulate emissions are reduced dramatically, as well as there is no black smoke due to the absence of aromatic compounds. Synergy Green Diesel conforms to EURO VI standards and outperforms petroleum diesel in performance, mileage & price.",

  description2:
    "Though we serve all commercial sectors, our focus market is Non-Transport, as we ensure last mile connectivity. Accordingly, Synergy Green Diesel has specially formulated for stationary Engines & Gensets to use as a drop in fuel. Since Synergy Green Diesel is available On-Site, our primary focus is to serve those consumers who find difficulty in carrying fuel from Petroleum Retail Outlet to end location.",

  description4:
    "Though we serve all commercial sectors, our focus market is Non-Transport, as we ensure last mile connectivity. Accordingly, Synergy Green Diesel has specially formulated for stationary Engines & Gensets to use as a drop in fuel. Since Synergy Green Diesel is available On-Site, our primary focus is to serve those consumers who find difficulty in carrying fuel from Petroleum Retail Outlet to end location .",
  description5: "",
};

export const synergyContent = {
  title: "Leading Supplier of Compressed Biogas Solutions",
  subtitle:
    "Pioneering clean energy with sustainable and efficient biogas technologies.",
  icons: [
    { src: synergyContenticon, alt: "Icon 1" },
    { src: synergyContenticon1, alt: "Icon 2" },
    { src: synergyContenticon2, alt: "Icon 3" },
  ],
};

export const cbgabout = {
  cbgmage2: cbgimage,
  clienticon: areaCapacity,

  // Titles
  title1: "Compressed",
  title2: "Biogas (CBG)!",
  title3: "", // No third title needed

  // Description
  description1:
    "We are driving the transition towards a sustainable future with Compressed Biogas (CBG). Our advanced technology enables efficient production, storage, and distribution, reducing dependency on fossil fuels and cutting carbon emissions.",

  description2:
    "With the increasing global focus on renewable energy sources, CBG plays a crucial role in achieving energy security and environmental sustainability. It provides a cleaner, greener alternative to traditional fuels, ensuring a better tomorrow.",

  // Subtitle (For the Right Section)
  subtitle:
    "How can Compressed Biogas (CBG) revolutionize energy consumption while promoting environmental sustainability?",

  // Bullet Points (List)
  points1: "High energy efficiency and reduced emissions",
  points2: "Utilization of agricultural and organic waste",
  points3: "Sustainable and cost-effective fuel alternative",
};

export const features = {
  title: "Sustainable, Reliable & Affordable Energy",
  description:
    "With advancements in CBG production and efficiency, our industry expertise enables us to provide in-depth material sourcing, financing, and supply chain solutions for sustainable and scalable biogas energy systems.",
  buttonText1: "Get Started",
  buttonText2: "Explore Our Plans",
  contactText:
    "If you have any questions or need help, feel free to contact our team anytime at",
  contactNumber: "(800) 0100 01404",
  estimateText: "Free Estimate",
  bgImage: cbgbg,
  cards: [
    {
      icon: "♻️", // Recycling/renewable energy
      title: "Green Energy Solution",
      description:
        "Harness the power of organic waste to generate clean and renewable biogas energy.",
    },
    {
      icon: "📋", // Planning & documentation
      title: "Consult & Planning",
      description:
        "Our experts provide end-to-end planning for efficient and sustainable CBG production.",
    },
    {
      icon: "🔬", // Innovation & technology
      title: "Advanced Technology",
      description:
        "Utilizing cutting-edge purification and compression techniques for high-quality CBG.",
    },
    {
      icon: "💰", // Cost-saving & financial benefits
      title: "Cost & Environmental Benefits",
      description:
        "Reduce fuel costs and carbon emissions by switching to eco-friendly CBG solutions.",
    },
  ],
  thumbnail: {
    image: "cbg-video-thumbnail.jpg",
    alt: "CBG Production Video",
  },
};

export const energyData = {
  bgImage: cbgbg,
  title: "Commercial, Residential & Industrial Systems!",
  description:
    "Providing end-to-end solutions for clean and sustainable energy across various sectors.",
  buttonText: "Access 1.5 Million ➜",
  statistics: [
    {
      title: "6,154 Projects",
      description:
        "Total biogas installations across industries, residential buildings, and storage facilities.",
    },
    {
      title: "2,512 Employees",
      description:
        "We have trained technicians working on biogas, solar, and clean energy products.",
    },
  ],
  testimonials: [
    {
      quote:
        "Synergy Teletech have proven their credentials in developing customized integrated Web based solutions for applications like diesel filling, particularly impressed with their passion and process based approach while designing solutions",
      name: "-	Shailendra Walia, DGM - SCM, Indus Towers Ltd, Corporate Office",
    },
    {
      quote:
        "Before starting services from FillNow, Assurance of Quality and Quantity of delivered fuel could not be monitored remotely. With automated delivery, our members have the assurance that they pay for exactly what has been delivered to them. Tried, Tested, Credible, Reliable, Affordable, Readymade solution for Diesel Supply.",
      name: "-	Rajiv Chawla, Chairman, IamSMEofIndia",
    },
    {
      quote:
        "We have been using FillNow service from Synergy Teletech for quite some time now. We are extremely satisfied with their professional and timely services. Ever since we have started dealing with them our fuel spend reconciliation has become so much simple",
      name: "– Kamal Mewani, AGM (Plg), BSNL Faridabad",
    },
    {
      quote:
        "Safety while handing fuel is one of our main concerns. The FillNow Refuellers come with trained drivers and duty managers. Their refullers have Fire Extinguishers and other equipments to handle emergency situations. Professional handling also means no fuel spillage. This is definitely the right way to deliver fuel.",
      name: "–	Manish Yadav, Facility Manager, Amazon Seller Services Pvt Ltd",
    },
    {
      quote:
        "FillNow delivers fuel to our doorsteps through a simple call. Now I need not send my staff to Petroleum Retail Outlets for carrying hazardous fuel. Not only I save on transportation cost, Fillnow has also been cost effective because of the huge discounts that they offer",
      name: "– Ashish Kalra, Director, Weartech Alloys Pvt Ltd, Palwal",
    },
    {
      quote:
        "Fuel Pilferage was one of our main concerns for making ourselves more cost efficient. FillNow has plugged the fuel pilferage completely and has always kept customer’s interest first. Their constant feedback mechanism has helped them to design very customer centric features",
      name: "-	Nitin M. Chhabra, Managing Director, Sunbeam Enterprises, IMT Manesar",
    },
    {
      quote:
        "The work of Synergy Teletech is found to be satisfactory as per standards of the Department.",
      name: "-	H. N. Tyagi, AGM (Plg), BSNL Meerut",
    },
  ],

  mapImage: mapbg,
};

export const projects = [
  {
    id: 1,
    image: advcbg,
    category: "Renewable Energy, Biogas",
    title: "Empowering CBG Solutions with Synergy Teletech",
    description:
      "Driving innovation in biogas technology to enhance efficiency, reduce emissions, and advance sustainable energy initiatives.",
  },
  {
    id: 2,
    image: supplychain,
    category: "Sustainability, Supply Chain",
    title: "Streamlining CBG Supply Chain with Synergy Teletech",
    description:
      "Optimizing logistics and distribution networks to improve biogas delivery, ensuring efficiency and environmental benefits.",
  },
  {
    id: 3,
    image: Newsimg2,
    category: "Innovation, Green Energy",
    title: "Innovative CBG Solutions by Synergy Teletech",
    description:
      "Introducing advanced CBG technologies to boost energy efficiency, reduce carbon footprints, and drive green innovation.",
  },
];

export const formContent = {
  title: "Request A Quote",
  description:
    "We supply high-quality Compressed Biogas (CBG) to power industries, businesses, and commercial operations. Our sustainable CBG solutions ensure cost-effective, eco-friendly energy tailored to your needs.",
  heading: {
    subheading: "Advancing The Future Of Compressed Biogas.",
    mainTitle: "Unlock Energy Independence With Sustainable CBG Solutions!",
    paragraph:
      "We provide innovative solutions, cutting-edge technology, and expert services across the biogas value chain. Our mission is to support a greener future with efficient and sustainable CBG energy systems.",
  },
  fields: {
    gasConsumption: "Monthly CBG gas?",
    deliveryTime: "First delivery date?",
    usagePurpose: "Purpose of CBG gas?",
    supplyType: "Bulk or regular supply?",
    contractDuration: "Short or long-term contract?",
    email: " Email ",
    mobile: " Mobile ",
  },
  placeholders: {
    gasConsumption: "Enter estimated monthly consumption (e.g., 10,000 m³)",
    email: "Enter your Email",
    mobile: "Enter your Mobile Number",
  },
  buttons: {
    submit: "Submit Request",
    learnMore: "Learn More",
    coreValues: "Our Core Values",
  },
  quoteText:
    "Get a precise quote within 1-2 days when you fill out this form. For immediate assistance, call us at: +91 8686062620, +91 8686062621",
};

export const Fillnow = {
  heroImg: Fillbgimg,
  title: "Overview ",
  description:
    "FillNow is the Fully Automated On-Site Fuel Delivery Service that comes to your location and delivers fuel directly into your equipment – when and where you need it. It eliminates the need for you to store bulk fuel on site and all the problems with self-fueling your own vehicles and machinery.",

  description1:
    "FillNow has a fleet of specially designed vehicles that can maneuver into difficult places on site to deliver small amounts of fuel to you as economically as possible, for filling all types of stationary equipments, eg Gensets, mobile plant, factories etc or vehicles in your parking hubs. The best part is that we provide automated reports on real time basis, so that you get billed only to the quantity of fuel supplied to you.",
  description2:
    "There are many businesses that choose to use FillNow. Typically, these businesses are concerned about safety and environment issues, difficulties in carrying fuel, fuel contamination, theft and vandalism, administration and efficient utilization of staff. Also, with FillNow we assure you a quick and hassle free reconciliation of all your fuel spends Synergy Green Diesel is a revolutionary distilled grade Bio Diesel made from a variety of feedstock.It can be used as a substitute for Regular Diesel in existing Diesel engines. No modification is required on the engines to switch over from Diesel to SGD",
  description3:
    "FillNow eliminates the loopholes in the conventional method of refueling by catering fully automated On-Site refueling in stationary equipments. FillNow converts the highly unprofessional, unorganized way of carrying fuel to a very professional and organized way. On-site Refueling provides delivery of diesel at the location of the equipment (for eg. DGs) by our very robust On-Site Refueling Vehicle (OSRV) that can measure and deliver fuel as per customer needs. This mechanism of service is first of its kind in India. Our automated refueller is also awaiting patent.",
  description4: "",
};

export const SynergyFillnow = [
  {
    image: fil1,
    title: "Automatic receipt generation",
    description:
      "After fueling your equipments, a receipt is generated automatically by our application containing all refueling data and parameters of DG.",
  },
  {
    image: fil2,
    title: "Instant Alerts",
    description:
      " As soon as fuel is delivered, instant alert is triggered by our servers in form of SMS/Email.",
  },
  {
    image: fil3,
    title: "Fuel dispensation by GPS check",
    description:
      "We ensure that fuel is delivered only when our OSRV reaches the location. This is done by a complex mechanism of validating the actual location of the OSRV with that of the location of equipment.",
  },
  {
    image: fil4,
    title: "Real Time Data Synchronization",
    description:
      "As soon as receipt is generated, data is pushed to our servers on a real time basis. So, reports can be accessed almost instantly.",
  },
  {
    image: fil5,
    title: "Multiple mode of raising demand",
    description:
      "Request for fueling can be made in various ways such as through Mobile Apps, IVRS, web access and through integration of SMS controllers with DGs.",
  },
  {
    image: fil6,
    title: "RFID Authorization",
    description:
      "Ensures fuel is delivered inside Fuel Tank only. The nozzle stops delivering fuel as soon as it is pulled out of the range of tag (installed on DG Fuel tank).",
  },
];

export const FillBenefits = [
  {
    image: filbene1,
    title: "Safety",
    description:
      "B100 grade Bio Diesel conforming to BIS: 15607 made from Vegetable Oil Residue",
  },
  {
    image: filbene2,
    title: "Convenience",
    description:
      " Clean-burning fuel with zero aromatic compounds, reducing pollution by up to 80%.",
  },
  {
    image: filbene3,
    title: "Assurance",
    description:
      "Compatible with existing diesel engines, offering superior quality without requiring modifications",
  },
  {
    image: filbene4,
    title: "Reconciliation",
    description:
      "Reliable, timely fuel delivery at ₹2.00 per liter cheaper than regular diesel.",
  },
  {
    image: filbene5,
    title: "Prompt Delivery",
    description:
      "Reliable, timely fuel delivery at ₹2.00 per liter cheaper than regular diesel.",
  },
  {
    image: filbene6,
    title: "Savings",
    description:
      "Reliable, timely fuel delivery at ₹2.00 per liter cheaper than regular diesel.",
  },
];

export const Galleryimage = [
  { id: 1, image: Gallary1 },
  { id: 2, image: Gallary2 },
  { id: 3, image: Gallary3 },
  { id: 4, image: Gallary4 },
  { id: 5, image: Gallary5 },
  { id: 6, image: Gallary6 },
  { id: 7, image: Gallary7 },
  { id: 8, image: Gallary8 },
  { id: 9, image: Gallary9 },
];

export const Galleryvideo = [
  {
    id: 1,
    name: "FillNow by Synergy Teletech",
    video: "https://youtu.be/GeS3Eo3ZBpQ?si=fwIuVVPIFdSe7xN9",
  },
  {
    id: 2,
    name: "FillNow by Synergy Teletech",
    video: "https://youtu.be/GeS3Eo3ZBpQ?si=fwIuVVPIFdSe7xN9",
  },
];

export const ItAutomation = {
  bgImage: Itbgimage,
  illustrationImage: Itautomation,
  title: "Overview",
  description:
    "We develop effective plans to move your customers behaviour. customer can be alwayes his profit.",

  itimage2: Itautomation2,
  title1: "About our",
  title2: "IoT & Cloud",
  title3: "automation firm.",
  description1:
    "Replacing a maintains the amount of lines. When replacing a selection, help industries to optimize fuel management and then automate. Maintains the amount of lines. When replacing a selection, help industries to optimize fuel management and then automate.",
  points1: "Geo-fenced tracking automated fuel delivery",
  points2: "Cloud-based monitoring real-time data insights",
  points3: "Safe secure services for your fuel transactions",
  points4: "Geo-fenced tracking automated fuel delivery",
};

export const cardContent = [
  {
    id: 1,
    image: cardimage1,
    title: "Smart Fuel Tracking",
    description:
      "IoT-enabled monitoring ensures seamless tracking of fuel levels. Businesses optimize delivery with real-time insights.",
  },
  {
    id: 2,
    image: cardimage2,
    title: "Automated Refueling",
    description:
      "Cloud-based automation streamlines fuel dispatch, reducing downtime. Industries benefit from precise, on-time delivery.",
  },
  {
    id: 3,
    image: cardimage3,
    title: "Fleet Management",
    description:
      "Real-time data helps industries monitor fleet operations efficiently. AI-driven analytics improve route optimization.",
  },
  {
    id: 4,
    image: cardimage4,
    title: "Secure Transactions",
    description:
      "RFID and geo-fencing enable safe, authorized fuel access. Fraud prevention enhances operational transparency.",
  },
  {
    id: 5,
    image: cardimage5,
    title: "Cloud-Based Analytics",
    description:
      "Advanced data solutions drive fuel insights and automation. AI-powered dashboards enhance decision-making.",
  },
];

export const Content = [
  {
    id: 1,
    label: "Research & solution",
    icon: design1,
    isActive: true,
    label1: "Enterprise AI and data platform solutions",
    description:
      "We provide AI-driven solutions to optimize fuel management, automate processes, and enhance operational efficiency. Our cutting-edge technology helps industries streamline workflows and improve decision-making.",
    bgimage: Research1,
    points: [
      "AI-powered fuel optimization and automation",
      "Real-time analytics for better decision-making",
      "Enhanced security and compliance monitoring",
      "Seamless integration with existing infrastructure",
    ],
  },
  {
    id: 2,
    label: "Design & strategy",
    icon: design2,
    isActive: false,
    label1: "Design and development use latest technology",
    description:
      "Our team focuses on designing and deploying scalable automation solutions tailored for fuel management, logistics, and cloud-based platforms. We prioritize efficiency, security, and innovation.",
    bgimage: Research2,
    points: [
      "Tailored IoT solutions for fuel monitoring",
      "Cloud-based infrastructure for automation",
      "User-friendly dashboards for real-time insights",
      "Custom API integrations for seamless operations",
    ],
  },
  {
    id: 3,
    label: "Artificial intelligence",
    icon: design3,
    isActive: false,
    label1: "Artificial intelligence use in automobile industry",
    description:
      "Leveraging AI and machine learning, we enable smart automation in fuel delivery and fleet management. Our AI-powered insights improve efficiency and reduce operational costs.",
    bgimage: Research3,
    points: [
      "AI-driven fleet tracking and fuel analytics",
      "Automated fuel station management",
      "Predictive maintenance for optimized operations",
      "Smart decision-making with real-time AI insights",
    ],
  },
  {
    id: 4,
    label: "Cloud deployment",
    icon: design4,
    isActive: false,
    label1: "Machine learning platform used cloud deployment",
    description:
      "We deploy cloud-based solutions that ensure secure, scalable, and efficient fuel automation. Our cloud infrastructure supports real-time data processing and intelligent automation.",
    bgimage: Research4,
    points: [
      "Secure cloud storage for fuel transaction data",
      "Real-time monitoring with cloud-based dashboards",
      "Automated reporting and compliance tracking",
      "Seamless connectivity with IoT-enabled devices",
    ],
  },
];

export const achievement = [
  {
    id: 1,
    image: Achieve1,
    title: "13+",
    description: "Years Experience",
  },
  {
    id: 2,
    image: Achieve2,
    title: "03",
    description: "Offices Worldwide",
  },
  {
    id: 3,
    image: Achieve3,
    title: "100+",
    description: "Experts Team",
  },
];

export const productCatogry = [
  {
    id: 1,
    image: catogry1,
    title: "Industries & Manufacturing",
  },
  {
    id: 2,
    image: catogry2,
    title: "Petroleum & Fuel Transportation",
  },
  {
    id: 3,
    image: catogry3,
    title: "CBG & Renewable Energy",
  },
  {
    id: 4,
    image: catogry4,
    title: "IoT & Automation",
  },
  {
    id: 5,
    image: catogry5,
    title: "Cloud & AI Solutions",
  },
];

export const sucessful = [
  {
    id: 1,
    image: sucessful1,
    title: "Environment Project",
    description:
      "Synergy Teletech leads sustainable initiatives by integrating IoT and automation to enhance energy efficiency and reduce environmental impact.",
  },
  {
    id: 2,
    image: sucessful2,
    title: "Design Solution",
    description:
      "Innovative design solutions that enhance industrial automation, ensuring seamless integration of smart technologies for efficiency and scalability.",
  },
  {
    id: 3,
    image: sucessful3,
    title: "Data Collection",
    description:
      "Advanced data collection systems enable real-time monitoring, analytics, and decision-making for optimized operational performance.",
  },
  {
    id: 4,
    image: sucessful4,
    title: "Models Development",
    description:
      "AI-driven modeling frameworks optimize automation and predictive analytics, improving industrial efficiency and ensuring seamless scalability.",
  },
  {
    id: 5,
    image: sucessful5,
    title: "Service Deployment",
    description:
      "Scalable automation deployment solutions enhance industrial connectivity, ensuring seamless IoT integration and secure real-time data processing.",
  },
];

// Support

export const Faqdata = {
  bgImage: Itbgimage,
  illustrationImage: faq,
  description: "Find answers to frequently asked questions here.",
  categories: {
    organicFertilizer: {
      title: "Organic fertilizer FAQs",
      faqs: [
        {
          question: "What are organic fertilizers and how are they different from chemical fertilizers?",
          answer:
            "Organic fertilizers are natural, biodegradable soil nutrients made from plant, animal, or organic waste. Unlike chemical fertilizers, they improve soil health, enhance fertility naturally, and leave no harmful residues.",
        },
        {
          question: "What ingredients are used to make organic fertilizers?",
          answer:
            "They are made from composted biomass, crop residue, manure, digestate from CBG plants, and organic matter rich in nutrients.",
        },
        {
          question:
            "How do organic fertilizers improve soil health?",
          answer:
            "They increase organic carbon, enhance microbial activity, improve soil structure, and promote long-term fertility.",
        },
        {
          question: "Are organic fertilizers safe for all types of crops?",
          answer:
            "Yes, organic fertilizers are completely safe and suitable for all crops—vegetables, fruits, cereals, pulses, sugarcane, and horticulture.",
        },
        {
          question: "How long does it take for organic fertilizers to show results?",
          answer:
            "Results typically appear within *2–4 weeks*, depending on soil condition and crop type.",
        },
        {
          question:
            "Can organic fertilizers increase crop yield effectively?",
          answer:
            "Yes. With regular use, organic fertilizers improve soil fertility and lead to healthier plants and better yields over time.",
        },
        {
          question: "Are organic fertilizers suitable for organic farming certification?",
          answer:
            "Yes, most organic fertilizers meet certification requirements as they contain no synthetic chemicals.",
        },
        {
          question:
            "How often should organic fertilizers be applied?",
          answer:
            "Application depends on the crop, but typically once every crop cycle or season is sufficient.",
        },
        {
          question:
            "Do organic fertilizers help in improving soil moisture retention?",
          answer:
            "Yes, organic fertilizers enhance soil’s water-holding capacity, reducing irrigation needs.",
        },
        {
          question: "Is it safe to use organic fertilizers alongside chemical fertilizers?",
          answer:
            "Yes, they can be used together, but using more organic fertilizers reduces dependency on chemicals.",
        },
        {
          question: "Are organic fertilizers environment-friendly?",
          answer:
            "Absolutely. They reduce pollution, improve soil health, and support sustainable agriculture.",
        },
        {
          question:
            " Can organic fertilizers reduce soil acidity or alkalinity?",
          answer:
            "Organic fertilizers help balance soil pH naturally over time.",
        },
        {
          question:
            "Do organic fertilizers contain beneficial microbes?",
          answer:
            "Yes, they contain microbes that improve nutrient availability and support plant growth.",
        },
        {
          question:
            "How do organic fertilizers help in long-term soil fertility?",
          answer:
            "They add organic matter, boost soil biology, and restore natural nutrient cycles.",
        },
        {
          question:
            "Are organic fertilizers cost-effective for farmers?",
          answer:
            "Yes, they reduce the need for expensive chemicals and improve soil over time, lowering long-term farming costs.",
        },
        {
          question:
            "Can organic fertilizers be used for vegetables and fruit crops?",
          answer:
            "Yes, they are ideal for vegetables, fruit orchards, and kitchen gardens.",
        },
        {
          question:
            "What is the shelf life of organic fertilizers?",
          answer:
            "The shelf life is typically *1–2 years* if stored properly.",
        },
        {
          question:
            "How should organic fertilizers be stored?",
          answer:
            "Store in a cool, dry place, away from direct sunlight and moisture.",
        },
        {
          question:
            "Are organic fertilizers safe for groundwater and the environment?",
          answer:
            "Yes, they do not release harmful chemicals or pollutants, making them safe for the environment.",
        },
        {
          question:
            "How is Saksham® Organic Fertilizer different from regular biofertilizers?",
          answer:
            "Saksham® is produced as a by-product of our CBG plant, making it nutrient-rich, eco-friendly, and more balanced than standard biofertilizers.",
        },
      ],
    },
    cbg: {
      title: "CBG FAQs",
      faqs: [
        {
          question: "What is CBG?",
          answer:
            "CBG (Compressed Bio-Gas) is a renewable gas produced from organic waste such as agricultural residue, animal manure, and municipal solid waste. It is purified to contain more than 90% methane, making it a sustainable alternative to conventional fossil fuels.",
        },
        {
          question: "How is CBG different from LPG or CNG?",
          answer:
            "CBG is derived from biological sources, whereas LPG is a petroleum by-product and CNG is extracted from natural gas reservoirs. CBG has similar calorific value and properties to CNG, making it an effective replacement for conventional fuels.",
        },
        {
          question: "What are the benefits of using CBG?",
          answer:
            "CBG is an eco-friendly fuel that reduces greenhouse gas emissions, improves waste management, and promotes energy self-sufficiency. It also enhances rural economies by providing additional income sources for farmers through organic waste utilization.",
        },
        {
          question: "Can CBG be used in existing CNG vehicles?",
          answer:
            "Yes, CBG has similar chemical and physical properties to CNG, so it can be used in existing CNG-powered vehicles without modification.",
        },
        {
          question: "How is CBG produced?",
          answer:
            "CBG is produced through anaerobic digestion, a process where organic waste decomposes in an oxygen-free environment, generating biogas. This raw biogas is then purified to remove impurities, leaving behind methane-rich CBG suitable for commercial use.",
        },
        {
          question: "Is CBG cost-effective compared to other fuels?",
          answer:
            "CBG is competitively priced compared to conventional fossil fuels. It also offers long-term cost benefits by reducing dependence on imported fuels and contributing to energy security.",
        },
        {
          question: "Does CBG help in reducing environmental pollution?",
          answer:
            "Yes, CBG significantly reduces CO2 emissions and helps in managing organic waste, preventing methane leakage into the atmosphere, which is a major contributor to climate change.",
        },
        {
          question: "What infrastructure is needed to use CBG?",
          answer:
            "CBG can be stored, transported, and dispensed using existing CNG infrastructure, including pipelines and refueling stations, making its adoption seamless.",
        },
        {
          question: "Is CBG safe to use?",
          answer:
            "Yes, CBG is a safe fuel with similar handling and storage requirements as CNG. It has a high ignition temperature and disperses quickly in case of leaks, minimizing fire hazards.",
        },
        {
          question: "What are the potential applications of CBG?",
          answer:
            "CBG can be used in transportation (as a fuel for vehicles), power generation, and industrial applications. It can also be injected into natural gas pipelines to supplement conventional gas supplies.",
        },
      ],
    },
    def: {
      title: "DEF FAQs",
      faqs: [
        {
          question: "What is DEF?",
          answer:
            "Diesel Exhaust Fluid (DEF) is a non-toxic, colorless, and odorless solution composed of 32.5% urea and 67.5% deionized water. It is used in diesel engines equipped with Selective Catalytic Reduction (SCR) technology to reduce harmful emissions and comply with environmental regulations.",
        },
        {
          question: "How does DEF help in emission control?",
          answer:
            "DEF is injected into the exhaust stream of diesel engines, where it reacts with nitrogen oxides (NOx) in the SCR catalyst to convert them into nitrogen and water vapor, significantly reducing air pollution and ensuring compliance with emission standards.",
        },
        {
          question: "Is DEF harmful or dangerous to handle?",
          answer:
            "No, DEF is non-toxic, non-flammable, and safe to handle. However, it should be stored properly in a clean, sealed container to prevent contamination and degradation.",
        },
        {
          question: "How should DEF be stored?",
          answer:
            "DEF should be stored in a cool, dry place away from direct sunlight and extreme temperatures. The ideal storage temperature is between -11°C and 30°C. Exposure to high temperatures can reduce its shelf life.",
        },
        {
          question: "What is the shelf life of DEF?",
          answer:
            "Under proper storage conditions, DEF has a shelf life of approximately 12 to 24 months. Storing it at high temperatures for prolonged periods can reduce its effectiveness.",
        },
        {
          question: "What happens if DEF runs out in a vehicle?",
          answer:
            "If a diesel vehicle runs out of DEF, most modern engines will enter a reduced power mode or limit performance to encourage refilling. Some vehicles may not start until DEF is replenished.",
        },
        {
          question: "Can DEF be mixed with other fluids or additives?",
          answer:
            "No, DEF should never be mixed with any other fluid, such as water, fuel, or additives, as this can damage the SCR system and lead to costly repairs.",
        },
        {
          question: "Does DEF freeze in cold temperatures?",
          answer:
            "Yes, DEF freezes at -11°C (12°F). However, it will not lose its effectiveness once thawed, and most modern diesel vehicles have built-in DEF heating systems to prevent freezing-related issues.",
        },
        {
          question: "Where can I buy DEF?",
          answer:
            "DEF is available at fuel stations, automotive retailers, truck stops, and industrial suppliers. It is also sold in bulk for fleet operations.",
        },
        {
          question: "How much DEF does a vehicle consume?",
          answer:
            "DEF consumption varies based on engine size, load, and driving conditions. Typically, DEF is consumed at a rate of about 2-3% of diesel fuel usage, meaning for every 100 liters of diesel, around 2-3 liters of DEF is used.",
        },
        {
          question: "Can I make my own DEF?",
          answer:
            "No, DEF must meet ISO 22241 quality standards to ensure proper functioning. Homemade or contaminated DEF can damage the SCR system and void vehicle warranties.",
        },
        {
          question: "How do I know if DEF is of good quality?",
          answer:
            "High-quality DEF should be clear and free from contaminants. Always purchase DEF from a reliable supplier and check that it meets ISO 22241 standards.",
        },
        {
          question: "Is DEF required for all diesel vehicles?",
          answer:
            "DEF is required for diesel vehicles equipped with SCR technology, which is commonly found in modern heavy-duty trucks, buses, and some passenger vehicles to meet emission standards.",
        },
        {
          question: "Can DEF be transported in any container?",
          answer:
            "DEF should be transported in dedicated DEF containers made of approved materials such as high-density polyethylene (HDPE) to prevent contamination.",
        },
        {
          question: "Does DEF affect fuel efficiency?",
          answer:
            "While DEF itself does not impact fuel efficiency directly, the use of SCR technology allows engines to run more efficiently, potentially improving overall fuel economy.",
        },
      ],
    },
    bowser: {
      title: "Bowser FAQs",
      faqs: [
        {
          question: "What is a Bowser?",
          answer:
            "A fuel bowser is a mobile fuel dispensing unit used to store and transport fuel such as diesel, petrol, or aviation fuel. It is commonly used in industries that require on-site refueling of machinery and vehicles.",
        },
        {
          question: "What are the applications of a Bowser?",
          answer:
            "Bowsers are widely used in industries like construction, mining, agriculture, and logistics for on-site refueling of heavy machinery, generators, and vehicles. They help reduce downtime and improve operational efficiency.",
        },
        {
          question: "What types of fuel can a Bowser carry?",
          answer:
            "Bowsers are designed to transport various types of fuels, including diesel, petrol, aviation fuel, and even water or AdBlue (Diesel Exhaust Fluid) in specialized units.",
        },
        {
          question: "What are the benefits of using a Bowser?",
          answer:
            "Using a bowser ensures fuel availability in remote locations, reduces fuel wastage, improves efficiency by eliminating the need for frequent trips to fuel stations, and enhances safety in fuel storage and handling.",
        },
        {
          question: "Are Bowsers available in different sizes?",
          answer:
            "Yes, bowsers come in various sizes and capacities, ranging from small portable units to large tankers that can store thousands of liters of fuel, depending on the requirement.",
        },
        {
          question: "How is fuel dispensed from a Bowser?",
          answer:
            "Bowsers are equipped with fuel pumps, flow meters, hoses, and nozzles, allowing controlled and efficient dispensing of fuel to machinery, vehicles, and equipment on-site.",
        },
        {
          question: "Are Bowsers safe to use?",
          answer:
            "Yes, bowsers are built with high safety standards, including leak-proof tanks, fire-resistant materials, and secure dispensing mechanisms to prevent fuel spillage and accidents.",
        },
        {
          question: "Can a Bowser be customized for specific needs?",
          answer:
            "Yes, fuel bowsers can be customized with features such as multiple compartments for different fuels, GPS tracking, flow meters, filtration systems, and additional security measures based on operational requirements.",
        },
        {
          question: "What maintenance is required for a Bowser?",
          answer:
            "Regular maintenance includes checking for leaks, ensuring the pump and meter system function correctly, cleaning filters, and inspecting hoses and nozzles for wear and tear to ensure safe and efficient operation.",
        },
        {
          question: "How do I choose the right Bowser for my needs?",
          answer:
            "The choice of a bowser depends on factors such as fuel capacity requirements, mobility needs, type of fuel, and specific industry applications. Consulting with a fuel storage expert can help in selecting the right bowser for optimal performance.",
        },
      ],
    },
    fillnow: {
      title: "IT Automation FAQs",
      faqs: [
        {
          question: "What is IT automation?",
          answer:
            "IT automation uses software, tools, and scripts to automate repetitive IT tasks such as monitoring, system updates, backups, and workflows, reducing manual effort and errors.",
        },
        {
          question: "Why is IT automation important for businesses?",
          answer:
            "It increases efficiency, reduces downtime, enhances accuracy, improves productivity, and saves operational costs.",
        },
        {
          question: "What processes can be automated in IT operations?",
          answer:
            "Server monitoring, ticketing, backups, software deployment, reporting, security updates, cloud provisioning, and workflow approvals can all be automated.",
        },
        {
          question: "Can IT automation reduce manpower costs?",
          answer:
            "Yes. It eliminates manual repetitive tasks, enabling teams to focus on strategic work, which reduces labor hours and operational expenses.",
        },
        {
          question: "Does IT automation improve security?",
          answer:
            "Absolutely. Automated security patches, threat detection, and compliance checks significantly reduce vulnerabilities.",
        },
        {
          question: "Is IT automation suitable for small and mid-size companies?",
          answer:
            "Yes. Automation tools are scalable and cost-effective, making them ideal for businesses of all sizes.",
        },
        {
          question: "Can automation tools work with our existing systems?",
          answer:
            "Yes. Modern automation platforms seamlessly integrate with existing software, cloud systems, databases, and infrastructure.",
        },
        {
          question: "Will automation reduce human involvement?",
          answer:
            "Automation reduces manual workload but does not replace humans entirely. It supports teams by handling repetitive tasks so they can focus on high-value work.",
        },
        {
          question: "How quickly can IT automation be implemented?",
          answer:
            "Implementation depends on the complexity but many workflows can be automated within days to weeks.",
        },
        {
          question: "What type of tasks benefit most from automation?",
          answer:
            "Tasks that are repetitive, rule-based, time-consuming, or prone to human error—such as monitoring, data entry, patching, or ticket management.",
        },
        {
          question:
            "How does IT automation help in reducing downtime?",
          answer:
            "Automated monitoring instantly detects issues and triggers alerts or corrective actions before systems fail.",
        },
        {
          question: "Is training required to use automation tools?",
          answer:
            "Minimal training is required. Most tools have user-friendly dashboards and drag-and-drop workflow creation.",
        },
        {
          question: "Can automation be customized for specific business needs?",
          answer:
            "Yes. Custom workflows, scripts, and integrations can be designed based on your exact operational requirements.",
        },
        {
          question: "What are the key benefits of IT automation?",
          answer:
            "Faster operations, reduced errors, improved security, 24/7 monitoring, cost savings, scalability, and better service delivery.",
        },
        {
          question: "Does IT automation support cloud environments?",
          answer:
            "Yes. Automation works seamlessly with AWS, Azure, Google Cloud, and hybrid environments.",
        },
        {
          question: "Can automation tools generate reports automatically?",
          answer:
            "Yes. You can schedule reports for performance, incident logs, compliance, user activity, and more.",
        },
        {
          question: "Is IT automation safe?",
          answer:
            "Yes. Automation significantly reduces human errors, ensures consistent execution, and enhances system security.",
        },
        {
          question: "How does IT automation help in compliance management?",
          answer:
            "Automated checks ensure that policies, security standards, and data compliance requirements are followed consistently.",
        },
        {
          question: "What industries benefit from IT automation?",
          answer:
            "All industries—IT services, manufacturing, logistics, finance, healthcare, retail, and telecom benefit from automation.",
        },
        {
          question: "How is your IT automation solution different?",
          answer:
            "We offer customizable automation workflows, real-time monitoring dashboards, seamless integrations, 24/7 alerts, and end-to-end support tailored to your business needs.",
        }
       
      ],
    },
  },
};

// export const Faqdata = {
//   bgImage: Itbgimage,
//   illustrationImage: faq,
//   description: "Find answers to frequently asked questions here.",
//   faqs: [
//     {
//       question: "What is Synergy Green Diesel?",
//       answer:
//         "Synergy Green Diesel is a revolutionary distilled Bio Diesel that can be used as a drop-in fuel in stationary equipment like gensets and in high blend ratio with diesel in transport vehicles. It is a feedstock neutral B100 grade product made from Acid Oils, PFAD, Animal Fats, etc.",
//     },
//     {
//       question: "Which standards does Synergy Green Diesel conform to?",
//       answer:
//         "Synergy Green Diesel fully conforms to BIS 15607:2016 and EU 14214 standards.",
//     },
//     {
//       question: "Can Synergy Green Diesel be used in my existing diesel engine without any modification?",
//       answer:
//         "No modification is required to be done on existing diesel engines for using SYNERGY GREEN DIESEL. Synergy Green Diesel can be used in any existing diesel engine on a standalone basis. It can be used as a drop-in fuel in stationary engines like gensets. However, we recommend mild blending with diesel (>B75) before using in vehicles.",
//     },
//     {
//       question: "Is Synergy Green Diesel environment friendly?",
//       answer:
//         "Synergy Green Diesel contains negligible aromatic compounds, hence pollution is very less. CO2 emission is approx. 80% less, and particulate matter emission is practically absent. There is also very less NOx emission.",
//     },
//     {
//       question: "Does the use of Synergy Green Diesel increase mileage?",
//       answer:
//         "Because of the presence of oxygen in the fuel, the burning takes place more effectively, hence combustion is proper and residual smoke is less, resulting in improved efficiency of the fuel.",
//     },
//     {
//       question:
//         "Can regular diesel be used in the engine after using Synergy Green Diesel?",
//       answer:
//         "You can switch to use normal diesel anytime and in any blend with Synergy Green Diesel inside the diesel engine. Synergy Green Diesel and regular petroleum diesel can be used interchangeably without any effect on the engine.",
//     },
//     {
//       question: "Is Synergy Green Diesel cost-effective?",
//       answer:
//         "The Base market price of Synergy Green Diesel is cheaper than the Retail Selling Price of regular Petroleum Diesel. Hence it is highly cost-effective in such markets where discounts are very difficult to get. So at a cheaper price, you get a better and more efficient product.",
//     },
//     {
//       question:
//         "What properties of Synergy Green Diesel make it a better fuel than petroleum diesel?",
//       answer:
//         "Better combustion, lubrication (100% better), and high cetane number compared to regular diesel ensure more power, longer engine life, and better mileage. Synergy Green Diesel is an excellent solvent, so it keeps the engine cleaner from the inside.",
//     },
//     {
//       question:
//         "What extra maintenance will have to be done on using Synergy Green Diesel?",
//       answer:
//         "No extra maintenance is required. However, since Synergy Green Diesel is an excellent solvent and because of its cleansing properties, all the impurities and sediments inside the fuel tank and nozzles are wiped out on initial use. This may lead to a choking of the diesel filter. We advise all our customers not to panic if they find the diesel filters choked when using SGD in old diesel engines. The filter change frequency may increase initially, but once the engine has been thoroughly cleaned, the diesel engine will run smoothly without any hiccups. However, no such issues are seen if SGD is used in new diesel engines.",
//     },
//     {
//       question: "What are the chemical properties of Synergy Green Diesel?",
//       answer:
//         "Synergy Green Diesel fully conforms to BIS 15607:2016 standards. Some of the test values are: \nFlash Point: >140°C \nCetane Number: 59 \nDensity: 860 kg/m³ \nCFPP: 0°C",
//     },
//     {
//       question: "Is Synergy Green Diesel safer to handle?",
//       answer:
//         "Because of its high Flash Point, Synergy Green Diesel comes under the non-explosive category and is extremely safe to handle.",
//     },
//     {
//       question: "Tell about the Cold Flow properties of Synergy Green Diesel.",
//       answer:
//         "Synergy Green Diesel can be used all year round. Generally, Bio Diesels form a gel at temperatures below 15°C. Because of high-quality distillation and the addition of additives, SYNERGY GREEN DIESEL can be used even at temperatures lower than 0°C. All our customers in colder regions have reported that SYNERGY GREEN DIESEL can be used conveniently at 0°C.",
//     },
//   ],
// };

export const ContactusData = {
  background: contactimg,
  cards: [
    {
      image: location,
      title: "Registered address ",
      title2: "Plant Address ",
      details2:
        "Village. Beldra Jaunardar Ahtamal & Mubarrakpur Saharanpur UP (247551)",
      details:
        "C-110, sector 65, Noida  201301 GSTIN - 09AAPCS6165G1ZT",
    },
    {
      image: phone,
      title: "Phone Number",
      details: "+91 8686062620, +91 8686062621",
    },
  
    {
      image: email,
      title: "Email",
      details: "info@synergyteletech.com",
    },
  ],
  form: {
    title: "Get in touch",
    fields: [
      {
        id: "name",
        label: "Name",
        type: "text",
        placeholder: "Enter your Name",
      },
      {
        id: "mobile",
        label: "Mobile",
        type: "tel",
        pattern:"^\+?[0-9]{10,15}$",
        title: "Phone number must be exactly 10 digits",
        placeholder: "Enter your Mobile Number",
},

      {
        id: "email",
        label: "Email",
        type: "email",
        placeholder: "Enter a valid email address",
      },

      {
        id: "message",
        label: "Message",
        type: "textarea",
        placeholder: "Enter your message",
      },
    ],
    submitButton: "Submit",
  },
  additionalInfo: {
    intro:
      "At Synergy TeleTech, we’re here to assist with any questions about our products, services, or new opportunities. Your feedback is important, and we’re committed to exceptional customer service !",
    details:
      "Feel free to reach out through any of the following platforms, and our team will get back to you as soon as possible:",
  },
  socialLinks: [
    {
      href: "https://www.facebook.com/synergyteletech/",
      icon: FaFacebook,
      color: "#1877F2",
    },
    { href: "https://www.twitter.com", icon: RiTwitterXLine, color: "#000000" },

    {
      href: "https://www.instagram.com/synergyteletech/",
      icon: FaInstagram,
      color: "#C13584",
    },
    {
      href: "https://www.linkedin.com/company/synergy-teletech-private-limited/",
      icon: FaLinkedin,
      color: "#0A66C2",
    },
  ],
  locations: [
    {
      id: 1,
      name: "Noida Office",
      address:
        "Synergy Teletech Pvt Ltd  S C-110, Ground Floor, Sector 65, NOIDA 201 301",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14030.340024098128!2d77.3871!3d28.6204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5540e6f4d3d%3A0x62b42dcd264e91af!2sSector%2065%2C%20Noida!",
    },
    {
      id: 2,
      name: "Saharanpur Office",
      address:
        "Village: Beldra Jaunardar Ahtamal & Mubarrakpur Saharanpur UP (247551)",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3130.3641071196803!2d77.57854117500435!3d29.888347625950804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ebf250231e58b%3A0x7645010fe0a4befc!2sSynergy%20Teletech%20CBG%20Plant!5e1!3m2!1sen!2sin!4v1770640398594!5m2!1sen!2sin",
    },
  ],
};

// content.js
export const jobSectionContent = {
  heading: "Find the job that fits your life",
  subheading: "Where Talent Meets the Right Opportunity",
  description: `We’re transforming the recruitment process. Our goal is to help you find more than just a job; we connect you with opportunities that match your unique lifestyle and career aspirations. We believe in providing a personalized recruitment experience that empowers you to excel in your professional life while maintaining balance in your personal life.`,
  contactNumber: "+91 86860 62620",
  images: [
    { src: petrol, alt: "Job Section 1", style: "w-44 h-40 rounded-tr-[80px]" },
    {
      src: fabrication,
      alt: "Job Section 2",
      style: "w-44 h-40 rounded-tl-[80px]",
    },
    { src: circle, alt: "Job Section 3", style: "w-40 h-40 rounded-full" },
    {
      src: rectangle,
      alt: "Job Section 4",
      style: "w-96 h-40 ml-5 rounded-br-[100px] rounded-tl-[100px]",
    },
    {
      src: sales,
      alt: "Job Section 5",
      style: "w-48 h-40  rounded-bl-[120px]",
    },
  ],
};

export const recruitmentProcessContent = {
  title: "Our recruitment process",
  description: `Our recruitment process is focused on providing top-tier talent to meet your business needs. We ensure a smooth experience for both candidates and employers by aligning skills and roles..`,

  steps: [
    {
      image: hirings,
      title: "Job Req • Talent Sourcing",
      description1:
        "We begin by understanding your hiring needs, crafting job requisitions, and sourcing top talent through multiple channels to ensure a diverse pool of qualified candidates for the role.",
    },
    {
      image: interv,
      title: "Interview • Negotiation",
      description1:
        "Next, we conduct interviews to assess candidates’ skills, experience, and cultural fit, followed by transparent negotiations to ensure mutual alignment between candidates and your organization’s expectations.",
    },
    {
      image: select,
      title: "Induction • Final Placement",
      description1:
        "Once a candidate is selected, we guide them through the induction process, ensuring a smooth transition into the role and final placement, guaranteeing long-term success and satisfaction.",
    },
  ],
};

// content.js
export const missionvalue = {
  mission: {
    title: "Champion the Mission",
    subtitle: "Our mission & values",
    description:
      "Our mission and values drive everything we do. Rooted in a rich history of innovation and integrity, we aim to make a lasting impact by challenging norms, empowering change, and building a future defined by collaboration and purpose.",
  },
  values: {
    Integrity:
      "Integrity means being honest and having strong moral principles.",
    Teamwork: "Teamwork is the ability to work together toward a common goal.",
    Passion:
      "Passion is a strong enthusiasm or dedication to a cause or activity.",
    Respect: "Respect is showing consideration and appreciation for others.",
  },
  footer: {
    title: "Recruitment the way it should be",
    description:
      "We simplify recruitment with tailored solutions, ensuring the perfect match for long-term success....",
    contactEmail: "hr@synergyteletech.com",
    contactPhone: "+91 86860 62620",
  },
  images: {
    missionImage: laptop,
    footerImage: hrbtn,
  },
};





{
  /* Social Media Links */
}
{
  /* <div className="flex space-x-4 mt-4">
              {team.socialLinks &&
                Object.keys(team.socialLinks).map((platform, i) => (
                  <a
                    key={i}
                    href={team.socialLinks[platform]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 hover:text-gray-800"
                  >
                
                    {platform === "linkedin" && <FaLinkedin />}
                    {platform === "facebook" && <FaFacebook />}
                    {platform === "twitter" && <FaTwitter />}
                  </a>
                ))}
            </div> */
}
